// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingElements_wrapper__SSoxA","error":"LoadingElements_error__V9UoR","translate-y":"LoadingElements_translate-y__7d6qH"};